module.exports = __webpack_public_path__ + "static/assets/9cf47307ae8124b2341a7565613435f2.svg";